import React from "react";
import img from "../../images/vegetaliser.png";
import bg from "../../images/renaturer.png";

const GallyVegetaliser = () => {
  return (
    <div>
      <section
        className="p-4 text-center sm:p-6 md:p-10 lg:p-20 bg-black/70 bg-blend-overlay"
        style={{
          backgroundImage: `url(${bg})`,
          backgroundSize: "cover",
          backgroundRepeat: "no-repeat",
          backgroundPosition: "center",
        }}
      >
        <h1 className="text-xl font-bold text-center text-white sm:text-2xl md:text-3xl">
          Renaturer le ruisseau
        </h1>
        <div className="flex justify-center mt-4 sm:mt-6">
          <p className="max-w-3xl text-base text-white">
            Vers un Ru de Gally Plus Naturel et Résilient
          </p>
        </div>
      </section>
      <div className="container px-4 mx-auto mt-8 mb-10 sm:mt-20 sm:px-6 lg:px-8">
        <h2 className="text-xl font-bold text-center text-black">
          Rendre le paysage attractif
        </h2>
        <div className="grid grid-cols-1 gap-6 mt-6 md:grid-cols-2 sm:mt-8">
          <div className="text-start">
            <p className="text-base">
              Aménager le ru de Gally, c’est aussi concevoir des chemins de
              randonnée ou encore faciliter des balades équestres.{" "}
              <span className="text-primary">HYDREAULYS</span> s’attache à
              redonner un intérêt paysager à ce cours d’eau, si remanié au fil
              de l’histoire qu’il finissait par perdre de son charme. Mis en
              valeur, le ru de Gally constitue de nouveau une attraction pour de
              nombreux promeneurs. Ces aménagements paysagers recouvrent
              également un intérêt environnemental. Des techniques végétales
              sont ainsi employées pour{" "}
              <span className="text-primary">
                protéger les berges de l’érosion.
              </span>
            </p>
          </div>
          <div className="flex justify-center">
            <img
              src={img}
              alt="Landscape enhancement of Ru de Gally"
              className="w-full h-auto max-w-md rounded-lg sm:max-w-full"
            />
          </div>
        </div>
        <div className="  flex flex-col justify-center gap-6 mt-6 sm:mt-20 md:flex-row">
          <div className="flex-1 p-4 text-center bg-white border border-gray-200 rounded-lg shadow-xl sm:p-6">
            <div className="mx-auto mb-4 text-2xl sm:text-3xl">🚶‍♀️</div>
            <h3 className="mb-2 text-base font-semibold text-black">
              Création de chemins de randonnée
            </h3>
          </div>
          <div className="flex-1 p-4 text-center bg-white border border-gray-200 rounded-lg shadow-xl sm:p-6">
            <div className="mx-auto mb-4 text-2xl sm:text-3xl">🐎</div>
            <h3 className="mb-2 text-base font-semibold text-black">
              Aménagement de balades équestres
            </h3>
          </div>
          <div className="flex-1 p-4 text-center bg-white border border-gray-200 rounded-lg shadow-xl sm:p-6">
            <div className="mx-auto mb-4 text-2xl sm:text-3xl">🌿</div>
            <h3 className="mb-2 text-base font-semibold text-black">
              Mise en valeur paysagère du ru
            </h3>
          </div>
        </div>
      </div>
    </div>
  );
};

export default GallyVegetaliser;
